//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { PRIVACY_EXTERNAL_LINK, TOS_EXTERNAL_LINK } from "@Shared/@Utils/constants";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TermsLinks",
  props: {
    includeRights: {
      type: Boolean,
      default: true
    },
    clientLogin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    TOS_EXTERNAL_LINK() {
      return TOS_EXTERNAL_LINK();
    },
    PRIVACY_EXTERNAL_LINK() {
      return PRIVACY_EXTERNAL_LINK();
    }
  }
});